module.exports = __webpack_public_path__ + "static/media/cardIconTotal.0532e544.svg";